export const TriggerTypes = {
	FIRST_ALL_TIME: "1",
	FIRST_TODAY: "2",
	POLL_RESULT: "3",
	PREDICTION_RESULT: "4",
	RAFFLE_RESULT: "5",
	BINGO_RESULT: "6",
	CHAT_COMMAND: "7",
	SUB: "8",
	SUBGIFT: "9",
	CHEER: "10",
	FOLLOW: "11",
	RAID: "12",
	REWARD_REDEEM: "13",
	TRACK_ADDED_TO_QUEUE: "14",
	MUSIC_START: "24",
	MUSIC_STOP: "25",
	TIMER_START: "15",
	TIMER_STOP: "16",
	COUNTDOWN_START: "17",
	COUNTDOWN_STOP: "18",
	STREAM_INFO_UPDATE: "19",
	EMERGENCY_MODE_START: "20",
	EMERGENCY_MODE_STOP: "21",
	HIGHLIGHT_CHAT_MESSAGE: "22",
	CHAT_ALERT: "23",
	HYPE_TRAIN_COOLDOWN: "45",
	HYPE_TRAIN_APPROACHING: "26",
	HYPE_TRAIN_START: "27",
	HYPE_TRAIN_PROGRESS: "28",
	HYPE_TRAIN_END: "29",
	HYPE_TRAIN_CANCELED: "32",
	RETURNING_USER: "30",
	VOICEMOD: "31",
	TIMEOUT: "34",
	BAN: "35",
	UNBAN: "36",
	VIP: "37",
	UNVIP: "38",
	MOD: "39",
	UNMOD: "40",
	SCHEDULE: "41",
	ANY_MESSAGE: "42",
	COMMUNITY_CHALLENGE_PROGRESS: "43",
	COMMUNITY_CHALLENGE_COMPLETE: "44",
	// PRESENTATION:"46",//Twitch removed this feature
	SHOUTOUT_IN: "47",
	SHOUTOUT_OUT: "48",
	OBS_SCENE: "49",
	OBS_SOURCE_ON: "50",
	OBS_SOURCE_OFF: "51",
	SHIELD_MODE_ON: "52",
	SHIELD_MODE_OFF: "53",
	PIN_MESSAGE: "54",
	UNPIN_MESSAGE: "55",
	STREAM_ONLINE: "56",
	STREAM_OFFLINE: "57",
	COUNTER_ADD: "58",
	COUNTER_DEL: "59",
	COUNTER_MAXED: "60",
	COUNTER_MINED: "61",
	COUNTER_LOOPED: "62",
	RAID_STARTED: "63",
	SLASH_COMMAND: "64",
	OBS_INPUT_MUTE: "65",
	OBS_INPUT_UNMUTE: "66",
	OBS_PLAYBACK_STARTED: "67",
	OBS_PLAYBACK_ENDED: "68",
	OBS_PLAYBACK_PAUSED: "69", //Not actually used as they require an OBS plugin to be triggered
	OBS_PLAYBACK_RESTARTED: "70", //Not actually used as they require an OBS plugin to be triggered
	OBS_PLAYBACK_NEXT: "71", //Not actually used as they require an OBS plugin to be triggered
	OBS_PLAYBACK_PREVIOUS: "72", //Not actually used as they require an OBS plugin to be triggered
	OBS_FILTER_ON: "73",
	OBS_FILTER_OFF: "74",
	USER_WATCH_STREAK: "75",
	OBS_START_STREAM: "76",
	OBS_STOP_STREAM: "77",
	COUNTER_EDIT: "78",
	// HYPE_CHAT:"79",
	FOLLOWED_STREAM_ONLINE: "80",
	FOLLOWED_STREAM_OFFLINE: "81",
	HEAT_CLICK: "82",
	CLIP_CREATED: "83",
	GOXLR_FX_ENABLED: "84",
	GOXLR_FX_DISABLED: "85",
	GOXLR_BUTTON_PRESSED: "86",
	GOXLR_BUTTON_RELEASED: "87",
	GOXLR_SAMPLE_COMPLETE: "88",
	VALUE_UPDATE: "89",
	GOXLR_INPUT_MUTE: "90",
	GOXLR_INPUT_UNMUTE: "91",
	ANNOUNCEMENTS: "92",
	AD_STARTED: "93",
	AD_APPROACHING: "94",
	AD_COMPLETE: "95",
	TRACK_ADD_TO_QUEUE_FAILED: "96",
	QNA_START: "97",
	QNA_DELETE: "98",
	QNA_STOP: "99",
	USER_JOIN: "100", //private undocumented trigger type
	USER_LEAVE: "101", //private undocumented trigger type
	CREDITS_COMPLETE: "102",
	STREAMLABS_DONATION: "103",
	STREAMLABS_MERCH: "104",
	STREAMLABS_PATREON_PLEDGE: "105",
	KOFI_DONATION: "106",
	KOFI_MERCH: "107",
	KOFI_SUBSCRIPTION: "108",
	POLL_START: "109",
	PREDICTION_START: "110",
	STREAMELEMENTS_DONATION: "111",
	STREAMELEMENTS_MERCH: "112",
	TIPEEE_DONATION: "113",
	TIPEEE_SUB: "114",
	TIPEEE_RESUB: "115",
	BINGO_GRID_LINE: "116",
	BINGO_GRID_CELL: "117",
	BINGO_GRID_ALL: "118",
	BINGO_GRID_RESET: "119",
	BINGO_GRID_VIEWER_LINE: "120",
	WARN_CHATTER: "121",
	WARN_ACKNOWLEDGE: "122",
	RAFFLE_PICK_WINNER: "123",
	POWER_UP_MESSAGE: "124",
	POWER_UP_GIANT_EMOTE: "125",
	POWER_UP_CELEBRATION: "126",
	YOUTUBE_SUPER_CHAT: "127",
	YOUTUBE_SUPER_STICKER: "128",
	YOUTUBE_SUBSCRIPTION: "129",
	YOUTUBE_SUBGIFT: "130",
	VOICEMOD_SOUND_EFFECT: "131",
	WEBSOCKET_TOPIC: "132",
	STREAMLABS_CHARITY_TIP: "133",
	TILTIFY_TIP: "134",
	OBS_RECORDING_START: "135",
	OBS_RECORDING_STOP: "136",
	TWITCHAT_STARTED: "137",
	PATREON_NEW_MEMBER: "138",
	KOFI_COMMISSION: "139",
	TIKTOK_SUB: "140",
	TIKTOK_GIFT: "141",
	TIKTOK_LIKE: "142",
	TIKTOK_SHARE: "143",
	CLEAR_CHAT: "144",
	SUB_ONLY_ON: "145",
	SUB_ONLY_OFF: "146",
	FOLLOW_ONLY_ON: "147",
	FOLLOW_ONLY_OFF: "148",
	EMOTE_ONLY_ON: "149",
	EMOTE_ONLY_OFF: "150",
	SLOW_MODE_ON: "151",
	SLOW_MODE_OFF: "152",
	MONITOR_ON: "153",
	RESTRICT_ON: "154",
	MONITOR_RESTRICT_OFF: "155",
	TWITCH_CHARITY_DONATION: "156",
	PLAYABILITY_INPUT: "157",
	HIGHLIGHT_CHAT_MESSAGE_CLOSE: "158",
	MESSAGE_ANSWER: "159",
	GOAL_STEP_COMPLETE: "160",
	CHAT_POLL_START: "161",
	CHAT_POLL_RESULT: "162",
	CUSTOM_TRAIN_START: "163",
	CUSTOM_TRAIN_LEVEL_UP: "164",
	CUSTOM_TRAIN_COMPLETE: "165",
	CUSTOM_TRAIN_FAIL: "166",
	CUSTOM_TRAIN_COOLDOWN: "167",
	STREAMSOCKET_ACTION: "168",
	TWITCH_COMBO: "169",
	OBS_CONNECTED: "170",
	OBS_DISCONNECTED: "171",
	MANY_REPLIES: "172",
	QUIZ_COMPLETE: "179",
	POWER_UP_CUSTOM: "180",
	MELDSTUDIO_START_STREAM: "181",
	MELDSTUDIO_STOP_STREAM: "182",
	MELDSTUDIO_SCENE_CHANGE: "183",
	MELDSTUDIO_LAYER_VISIBILITY_CHANGE: "184",
	MELDSTUDIO_EFFECT_VISIBILITY_CHANGE: "185",
	MELDSTUDIO_TRACK_MUTE_CHANGE: "186",
	MODIVERSARY: "187",
	TWITCHAT_COMPANION_KEYS: "188",
	YOUTUBE_JEWELS: "189",
	RAFFLE_JOIN: "190",
	SHARED_CHAT_BEGIN: "191",
	SHARED_CHAT_JOIN: "192",
	SHARED_CHAT_END: "193",
	SHARED_CHAT_LEAVE: "194",

	TWITCHAT_AD: "ad",
	TWITCHAT_LIVE_FRIENDS: "live_friends",
	TWITCHAT_SHOUTOUT_QUEUE: "shoutout_queue",
	TWITCHAT_MESSAGE: "twitchat_message",
	GLOBAL_PLACEHOLDERS: "global_placeholders",
} as const;
export type TriggerTypesKey = keyof typeof TriggerTypes;
export type TriggerTypesValue = (typeof TriggerTypes)[TriggerTypesKey];
